/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { popupSelector } from "components/Popup/popupSlice";
import { minimizeAddress } from "libs/utils";
import React, { Fragment, useEffect, useState } from "react";
import { Media, Attribute } from 'types/nftSing';
import { CopyButton } from "./components/Copy";
import SendNft from "./components/SendNft";

export default function NftDetails() {
    const { nftToken, nftMetadata, nftDetails } = useAppSelector(popupSelector);
    const [sendNft, setSendNft] = useState(nftDetails);
    const handleSendNft = () => {
        setSendNft(!sendNft);
    }

    useEffect(() => {
        setSendNft(!nftDetails)
    }, [nftDetails])

    if (!nftToken) {
        return <></>
    }

    const thumb = nftMetadata ? nftMetadata.image || nftMetadata.thumb : '/assets/img/no-preview.png';
    const name = nftMetadata ? nftMetadata.name || nftMetadata.title : nftToken.name;
    const media = nftMetadata && nftMetadata.media ? nftMetadata.media as Media : undefined;
    const owner = nftToken ? nftToken.owner_of : ' ';
    const attribute = nftMetadata && nftMetadata.attributes ? nftMetadata.attributes as Attribute[] : undefined;

    return (
        <Fragment>
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    background: '#3E4357',
                    '& object': {
                        width: '100%',
                        aspectRatio: '1/0.98',
                        overflow: 'hidden',
                        objectFit: 'cover',

                    }

                }}
            >
                {media && media.mimeType.includes('video') ?
                    <video src={media.url} controls />
                    :
                    <>
                        <img src={thumb} alt="" />
                        {media && media.url && <audio src={media?.url} controls 
                        style={{
                            width: '100%',
                            background: '#20273F',
                        }}
                        />}
                    </>
                }

            </Box>
            <Box
                sx={{
                    position: 'relative',
                    background: '#20273F',
                    borderRadius: '0px 0px 24px 24px',
                    mb: sendNft ? 1 : 5.4,
                }}
            >
                <Typography
                    sx={{
                        fontSize: 20,
                        fontWeight: 700,
                        color: '#ffffff',
                        pt: 2,
                        px: 2,
                        pb: .7,
                    }}
                >
                    {name}
                </Typography>
                <Typography
                    sx={{
                        display: sendNft ? 'none' : 'block',
                        fontSize: 14,
                        fontWeight: 400,
                        color: '#ffffff',
                        pb: 6.6,
                        px: 2,
                    }}
                >
                    Owner:&nbsp;{minimizeAddress(owner, 8)}
                </Typography>
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: -30,
                        width: '100%',
                        display: sendNft ? 'none' : 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        sx={{
                            height: 60,
                            width: 230,
                            borderRadius: '32px',
                            background: 'rgba(49, 37, 97, 0.5)',
                            boxShadow: '0px 3px 10px #100E18',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                height: 44,
                                width: 215,
                                borderRadius: '24px',
                                background: 'linear-gradient(90deg, #BF26E6 -5.41%, #3C14DA 100%)',
                                boxShadow: '0px 3px 10px #100E18',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                                px: 2,
                            }}
                            onClick={handleSendNft}
                        >
                            <Box sx={{ width: 20 }}></Box>
                            <Typography
                                sx={{
                                    fontSize: 14,
                                    fontWeight: 700,
                                    color: '#ffffff',
                                }}
                            >
                                SEND NFT
                            </Typography>
                            <img src='/assets/img/ic-back.svg' alt='' />
                        </Box>
                    </Box>
                </Box>
            </Box>
            {sendNft &&
                <SendNft onClose={handleSendNft} token={nftToken} />
            }
            <Box
                sx={{
                    background: 'linear-gradient(90deg, #BF26E6 -5.41%, #3C14DA 100%)',
                    borderRadius: '24px',
                    display: attribute && !sendNft ? 'flex' : 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px',
                }}
            >
                <Box
                    sx={{
                        background: '#20273F',
                        borderRadius: '24px',
                        width: '100%',
                        px: 1.6,
                        pt: 2.7,
                        pb: 2.7,
                    }}
                >
                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                pt: 1.3,
                                pb: 1.5,
                                overflow: 'hidden',
                            }}
                        >

                            <Box sx={{ textAlign: 'left' }}>
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 400,
                                        color: '#B1BBD2',
                                        textTransform: 'capitalize',
                                    }}
                                    noWrap
                                >
                                    Contract Address
                                </Typography>

                            </Box>

                            <Box 
                            sx={{ 
                                textAlign: 'right',
                                display: 'flex',
                                alignItems: 'center',
                                 }}
                                 >
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 500,
                                        color: '#ffffff'
                                    }}
                                    noWrap
                                >
                                    {minimizeAddress(nftToken.token_address, 6)}
                                </Typography>
                                <CopyButton text={nftToken.token_address}/>
                            </Box>
                        </Box>
                    </Box>
                    <Divider />
                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                pt: 1.3,
                                pb: 1.5,
                                overflow: 'hidden',
                            }}
                        >

                            <Box sx={{ textAlign: 'left' }}>
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 400,
                                        color: '#B1BBD2',
                                        textTransform: 'capitalize',
                                    }}
                                    noWrap
                                >
                                    Token ID
                                </Typography>

                            </Box>

                            <Box 
                            sx={{ 
                                textAlign: 'right',
                                display: 'flex',
                                alignItems: 'center',
                                 }}
                                 >
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 500,
                                        color: '#ffffff'
                                    }}
                                    noWrap
                                >
                                    {nftToken.token_id}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    {attribute && attribute.length > 0 && attribute.map((item, index) => (
                        <Box key={index}>
                            <Divider />
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pt: 1.3, pb: 1.5, overflow: 'hidden', }}>

                                <Box sx={{ textAlign: 'left', maxWidth: '45%' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            fontWeight: 400,
                                            color: '#B1BBD2',
                                            textTransform: 'capitalize',
                                        }}
                                        noWrap
                                    >
                                        {item.trait_type}
                                    </Typography>

                                </Box>

                                <Box sx={{ textAlign: 'right', maxWidth: '45%' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            fontWeight: 500,
                                            color: '#ffffff'
                                        }}
                                        noWrap
                                    >
                                        {item.value}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>

        </Fragment>
    );
}